import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocationSummaryDto } from '../dtos/location-summary.dto';
import { environment } from '../../../../environments/environment';
import { AddLocationDto } from '../dtos/add-location.dto';
import { LocationDto } from '../dtos/location.dto';
import { MemoryService } from '../../../core/services/memory.service';
import { LocationOnlineBookingUrlsDto } from '../dtos/location-online-booking-urls.dto';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(private http: HttpClient, private customerIdService: MemoryService) {
  }

  getLocationSummaries(): Observable<LocationSummaryDto[]> {
    return this.http.get<LocationSummaryDto[]>(`${environment.cenplexBookingApiBaseUrl}/customers/${this.customerIdService.customerId}/locations`);
  }

  createLocation(addLocationDto: AddLocationDto): Observable<LocationDto> {
    return this.http.post<LocationDto>(`${environment.cenplexBookingApiBaseUrl}/customers/${this.customerIdService.customerId}/locations`, addLocationDto);
  }

  getLocation(locationId: number): Observable<LocationDto> {
    return this.http.get<LocationDto>(`${environment.cenplexBookingApiBaseUrl}/locations/${locationId}`);
  }

  updateLocation(locationDto: LocationDto): Observable<void> {
    return this.http.put<void>(`${environment.cenplexBookingApiBaseUrl}/locations/${locationDto.locationId}`, locationDto);
  }

  getOnlineBookingUrls(locationId: number): Observable<LocationOnlineBookingUrlsDto> {
    return this.http.get<LocationOnlineBookingUrlsDto>(`${environment.cenplexBookingApiBaseUrl}/locations/${locationId}/online-booking-urls`);
  }

  updateOnlineBookingUrls(locationOnlineBookingUrlsDto: LocationOnlineBookingUrlsDto): Observable<void> {
    return this.http.put<void>(`${environment.cenplexBookingApiBaseUrl}/locations/${locationOnlineBookingUrlsDto.locationId}/online-booking-urls`, locationOnlineBookingUrlsDto);
  }

  addLocationImage(locationId: number, formData: FormData): Observable<void> {
    return this.http.post<void>(`${environment.cenplexBookingApiBaseUrl}/locations/${locationId}/image`, formData);
  }

  deleteLocationImage(locationId: number): Observable<void> {
    return this.http.delete<void>(`${environment.cenplexBookingApiBaseUrl}/locations/${locationId}/image`);
  }
}
